const title = (title: string) => {
  try {
    return (
      <div style={{ whiteSpace: "pre-wrap", height: 50, lineHeight: title.includes("\r\n") ? "20px" : "auto", textAlign: "center" }}>{title}</div>
    );
  } catch (error) {
    return "";
  }
};
export default title;
